import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchMinisite } from '../../functions/fetchMinisite';
import RenderSnA from '../../functions/renderSnA';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface Content {
  type: string;
  text?: string;
  children?: Content[];
}

interface MinisiteData {
  id: number;
  Title: string;
  Slug: string;
  Header: boolean;
  Footer: boolean;
  Content: string | Content[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
}

const Minisite: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [minisite, setMinisite] = useState<MinisiteData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchMinisite(slug);
        if (response && response.data && response.data.length > 0) {
          const data = response.data[0].attributes;
          setMinisite(data);
        } else {
          setError('No data found');
        }
      } catch (err) {
        setError('Failed to fetch data');
      }
    };

    fetchData();
  }, [slug]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!minisite) {
    return <div>Loading...</div>;
  }

  const renderContent = (content: string | Content[]) => {
    if (typeof content === 'string') {
      return <div><ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown></div>;
    }

    return content.map((item, index) => (
      <div key={index}>
        {item.type === 'paragraph' && item.children && item.children.map((child, childIndex) => (
          <p key={childIndex}>{child.text}</p>
        ))}
        {item.children && renderContent(item.children)}
      </div>
    ));
  };

  return (
    <div>
      <RenderSnA seo={minisite.SEO} ga={minisite.GA} />
      {minisite.Header && <header>{minisite.Title}</header>}
      <main>
        {renderContent(minisite.Content)}
      </main>
      {minisite.Footer && <footer>Footer content here</footer>}
    </div>
  );
};

export default Minisite;